import { useContext } from 'react';
import { CreateTransactionsContext, CreateTransactionsValues } from '../contexts/CreateTransactionsContext';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography, useTheme } from '@mui/material';
import { InfoCircle } from '../../../../../../assets';
import { CloseDialogAction } from '../../../../../../components/shared/dialogs/CloseDialogAction';

export const CreateTransactionsChangeCostConfirmDialog = () => {
  const { closeCostChangeModal, isCostChangeModalOpen, t } = useContext(CreateTransactionsContext) as CreateTransactionsValues;
  const theme = useTheme();

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={isCostChangeModalOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoCircle color={theme.palette.custom.blue[500]} />
        </Box>
        <CloseDialogAction onCancel={closeCostChangeModal} />
      </DialogTitle>
      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}>{t('confirmPrice.title')}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1 }}
            variant="textSM">
            {t('confirmPrice.message')}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button sx={{ width: '100%' }}
          variant='primary'
          size="lg"
          onClick={() => { closeCostChangeModal(); }}>
          {t('confirmPrice.continue')}
        </Button>
      </DialogActions >
    </Dialog>
  );
};

